// extracted by mini-css-extract-plugin
export default {"weight":"QuantityIcon_weight__gIZnd","icon":"QuantityIcon_icon__CrMmh","gramCount":"QuantityIcon_gramCount__UXC16","gramLabel":"QuantityIcon_gramLabel__sKA59"};